import React from 'react'
import { Input, Button, Space, Select } from 'antd'
import type { ColumnType } from 'antd/es/table'

export const getColumnFilter = (dataIndex: string): ColumnType<any> => ({
  filterDropdown: ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters,
  }) => {
    const operator = selectedKeys?.[1] || 'contains'
    const keyword = selectedKeys?.[0]

    return (
      <div style={{ padding: 8, width: 220 }}>
        <Space direction="vertical" style={{ width: '100%' }}>
          <Select
            value={operator}
            style={{ width: '100%' }}
            onChange={value => setSelectedKeys([keyword, value])}
            options={[
              { label: 'Chứa', value: 'contains' },
              { label: 'Bắt đầu với', value: 'startsWith' },
              { label: 'Kết thúc với', value: 'endsWith' },
              { label: 'Bằng', value: 'equals' },
              { label: 'Không bằng', value: 'notEqual' },
            ]}
          />

          <Input
            placeholder="Lọc..."
            value={keyword}
            onChange={e => setSelectedKeys([e.target.value, operator])}
            onPressEnter={() => confirm()}
          />

          <Space
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <Button
              type="link"
              size="small"
              style={{ padding: 0 }}
              onClick={() => {
                clearFilters?.()
                confirm()
              }}
              disabled={keyword == undefined}
            >
              Reset
            </Button>

            <Button type="primary" size="small" onClick={() => confirm()}>
              OK
            </Button>
          </Space>
        </Space>
      </div>
    )
  },

  onFilter: () => true,
})
